import "./../../tools/bootstrapper";
import { componentMap as AEMComponents } from "./AEMComponents";
import { componentMap as SSRComponents } from "./SSRComponents";

window.hydrator.registerComponentMap("AEM", AEMComponents);
window.hydrator.registerComponentMap("SSR", SSRComponents);
window.hydrator.rehydrate();
